import { Box, Fab, Zoom, useScrollTrigger } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useEffect, useState } from 'react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100,
  });

  // Smooth scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Alternative with anchor (for React Router)
  // const scrollToTop = () => {
  //   const element = document.getElementById('top-anchor');
  //   if (element) {
  //     element.scrollIntoView({ behavior: 'smooth' });
  //   }
  // };

  useEffect(() => {
    setIsVisible(trigger);
  }, [trigger]);

  return (
    <Zoom in={isVisible}>
      <Box
        onClick={scrollToTop}
        role="presentation"
        sx={{
          position: 'fixed',
          bottom: 32,
          right: 32,
          zIndex: 1000,
        }}
      >
        <Fab
          color="primary"
          size="medium"
          aria-label="scroll back to top"
          sx={{
            color : "white",
            backgroundColor: "#032262",
            border : "1px solid #fff",
            boxShadow: 3,
            '&:hover': {
              transform: 'scale(1.1)',
              transition: 'transform 0.2s',
            }
          }}
        >
          <KeyboardArrowUpIcon fontSize="medium" />
        </Fab>
      </Box>
    </Zoom>
  );
};

export default ScrollToTop;